import { ApiClient, LogApi, TrackApi, ILogsResponse, ITracksResponse } from "../../Types"

export function dayToDate(day: number): Date {
  return new Date(Date.UTC(2001, 0, 1) + (day * 60 * 60 * 24 * 1000));
}

export const DayViewData = {
  loadLogs(api: ApiClient, shipId: number, dayId: number): Promise<ILogsResponse> {
    return new LogApi(api).logs.list({ params: { shipId, dayId } }).call();
  },
  loadDayTrack(api: ApiClient, shipId: number, dayId: number): Promise<ITracksResponse> {
    return new TrackApi(api).tracks.day({ params: { shipId, dayId } }).call();
  },
  // Saturday/Sunday get a weekend highlight; the 1st of a month gets a month highlight.
  isWeekend(date: Date): boolean {
    return date.getDay() == 0 || date.getDay() == 6;
  },
  monthHighlight(date: Date): boolean {
    return date.getDate() == 1;
  },
  // The detail panel shows when the day is expanded, is the current day, is
  // tomorrow while selected, or is a blank/backfilled day (#1137 -- a day with no
  // Day row yet always opens straight to its detail panel). The timeline shows
  // whenever the detail panel is hidden, additionally on the current day unless
  // the caller hid it, and always for a blank day (so its empty "No logs" strip
  // renders alongside the detail panel rather than the two being exclusive).
  showDetail(details: boolean, isCurrentDay: boolean, isTomorrow: boolean, selected: boolean, blank: boolean): boolean {
    return blank || details || isCurrentDay || (isTomorrow && selected);
  },
  showTimeline(showDetail: boolean, isCurrentDay: boolean, hideTimeline: boolean, blank: boolean): boolean {
    return blank || !showDetail || (isCurrentDay && !hideTimeline);
  },
};
